import React from "react";
import { Add } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";

import FormDrawer from "components/Shared/FormDrawer";


import ShippingRateForm from "./ShippingRateForm";
import ShippingRateList from "./ShippingRateList";
import { useCreateVendorShippingRateMutation, useLazyGetVendorShippingRateQuery } from "store/services/vendorProfileApi";

const ShippingRateTab = ({ vendorId, setTotalRates }) => {
    const [showForm, setShowForm] = React.useState(false);
    const [selectedRate, setSelectedRate] = React.useState(null);

    const handleCancel = () => {
        setShowForm(false);
        setSelectedRate(null);
    };

    // RTK Query
    const [fetchRates, { data: rateRes }] =
        useLazyGetVendorShippingRateQuery();

    const [addRate, { isLoading: adding }] =
        useCreateVendorShippingRateMutation();

    const totalRates = rateRes?.totalItems ?? 0;

    const handleAddRate = async (data) => {
        try {
            await addRate({
                vendorId,
                ...data,
            }).unwrap();

            toast.success("Shipping rate added successfully!");
            handleCancel();
        } catch (err) {
            toast.error(err?.data?.message ?? "Failed to add shipping rate!");
        }
    };

    React.useEffect(() => {
        if (vendorId) {
            fetchRates({ vendorId });
            if (setTotalRates) setTotalRates(totalRates);
        }
    }, [vendorId, fetchRates, setTotalRates, totalRates]);

    return (
        <>
            <Box display="flex" justifyContent="end" padding={3}>
                {!showForm && (
                    <Button
                        startIcon={<Add />}
                        variant="outlined"
                        onClick={() => setShowForm(true)}
                    >
                        Add Shipping Rate
                    </Button>
                )}
            </Box>

            <ShippingRateList vendorId={vendorId} setSelectedRate={setSelectedRate} setShowForm={setShowForm} />

            <FormDrawer
                title={selectedRate ? "Edit Shipping Rate" : "Add Shipping Rate"}
                open={showForm}
                onClose={handleCancel}
            >
                <ShippingRateForm
                    isBusy={adding}
                    shippingRate={selectedRate}
                    onCancel={handleCancel}
                    onSubmit={handleAddRate}
                />
            </FormDrawer>
        </>
    );
};

export default ShippingRateTab;
